import { AxfoodApi } from '@occ/api-client';

const axfoodApi = new AxfoodApi({
  baseUrl: '',
});
export const getCSRFToken = () => axfoodApi.getCsrfTokenUsingGet();
